import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {CalendarHoliday} from '../object-holiday.model';
import {ApiList} from '../../API/api-list.enum';
import {TranslateService} from '@ngx-translate/core';
import {SemRestRequestService} from '../../../../projects/api/src/sem-rest-request/sem-rest-request.service';
import {LocaleService} from '../../shared/services/locale.service';
import {DateTimeAdapter, OwlDateTimeIntl} from '@danielmoncada/angular-datetime-picker';
import {MatSnackBar} from '@angular/material/snack-bar';
import {environment} from '../../../environments/environment';
import {HolidayTemplate} from '../../../../projects/api/src/template/template.model';
import { SnackBarService } from '../snackbar-service';
import _ from 'lodash';
import {delay} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';

/**
 * Компонент для загрузки нескольких строк из таблицы CalendarHoliday
 * при получении единственного ID форма работает в режиме редактирования
 * при количестве ID больше 1 форма работает в декларативном стиле
 */
@Component({
    selector: 'app-calendar-holiday',
    templateUrl: './calendar-holiday.component.html',
    styleUrls: ['./calendar-holiday.component.scss'],
    standalone: false
})
export class CalendarHolidayComponent implements OnInit, OnChanges {
  @Input() ids: any;
  @Input() names: any;
  @Output() saved: EventEmitter<any> =  new EventEmitter<any>();
  public keepCalendar: HolidayTemplate = {};
  public keepData: CalendarHoliday[] = [];
  public calendarHolidays: CalendarHoliday[] = [];
  public showModalDialog = false;
  public modalDialogTemplate;
  public displayName = '';
  readonly DAY24 = 86400000;
  public map = new Map();
  public offset = 0;
  public isDisabled = false;
  private titleDisabled = '';

  constructor(private request: SemRestRequestService,
              private translate: TranslateService,
              private owlDateTimeIntl: OwlDateTimeIntl,
              private localeService: LocaleService,
              private dateTimeAdapter: DateTimeAdapter<Date>,
              private cd: ChangeDetectorRef,
              private snackBar: MatSnackBar,
              private snackBarService: SnackBarService,
              private router: Router,
              private route: ActivatedRoute
  ) {
    localeService.locale$.subscribe(locale => {
      dateTimeAdapter.setLocale(locale.serverShort);
    });

    this.addCalendarHoliday();
  }

  close(): void {
    this.router.navigate(['./'], {relativeTo: this.route.parent});
  }

  ngOnInit() {
    return;
  }

  ngOnChanges(data) {
    if (this.names && this.names[0]) {
      this.displayName = this.names[0].name;
    }
    if (this.ids[0] && this.ids[0] !== 0) {
      this.request.baseUrl = environment.backEndUrlPrefix;
      this.request.baseUrlAppendByStrParam(('/' + ApiList[ApiList.Db] +
        '/' + ApiList[ApiList.Calendar] + '/' + this.ids[0] + '/' + ApiList[ApiList.CalendarHoliday]).toLowerCase())
        .getAll<any>().subscribe(_data => this.parse(_data));
    }
  }

  /**
   * Функция выполняет разбор и мапинг данных, полученных из Rest, на внутренние структуры компонента
   * @param data
   */
  public parse(data) {
    this.map.clear();
    const newCalendarHolidays: CalendarHoliday[] = [];
    data.forEach(_calendarHoliday => {
      newCalendarHolidays.push({
        id: parseInt (_calendarHoliday.id, 10),
        date: parseInt(_calendarHoliday.date, 10),
        weekday: parseInt(_calendarHoliday.weekday, 10),
      });
      this.map.set(parseInt(_calendarHoliday.date, 10), parseInt (_calendarHoliday.id, 10));
    });
    /*ustas - можно поставить костыль по обновлению полей календаря, но это не правильно*/
    this.calendarHolidays = newCalendarHolidays.sort((a,b) => a.date.toString().localeCompare(b.date.toString()));
    this.keepData =  JSON.parse(JSON.stringify(this.calendarHolidays));
    this.keepCalendar = JSON.parse(JSON.stringify(this.names[0]));
    this.cd.markForCheck();
  }

  /** Выполняет формирование и вызов REST запросов */
  createCalendarHolidays() {
    const statusText = {success: [], error: []};
    try {
      if (this.names[0].id === 0) { /**ustas - creating a new calendar */
      const payload = {
          name: this.names[0].name,
          description: this.names[0].description,
        };
        this.request.baseUrl = environment.backEndUrlPrefix;
        this.request.baseUrlAppendByStrParam(('/' + ApiList[ApiList.Db] + '/' + ApiList[ApiList.Calendar]).toLowerCase())
          .postFormData(payload)
          .subscribe(result => {
              this.names[0].id = result.id;
              this.calendarHolidays.forEach(_calendarHoliday => {
                const  payload2 = {
                  date: _calendarHoliday.date + this.DAY24,
                  weekday: _calendarHoliday.weekday,
                  calendar: this.names [0]
                };
                this.request.baseUrl = environment.backEndUrlPrefix;
                this.request.baseUrlAppendByStrParam(('/' + ApiList[ApiList.Db] + '/' + ApiList[ApiList.CalendarHoliday]).toLowerCase())
                  .postData(payload2)
                  .subscribe(result2 => {
                      statusText.success.push(payload2.date + ': ' + this.translate.instant('Item successfully saved'));
                    }, error => {
                      statusText.error.push(payload2.date + ': ' + error.statusText);
                    }
                  );
              });
              statusText.success.push(this.translate.instant('Item successfully created'));
              this.saved.emit(statusText);
              this.close();
            }, error => {
              statusText.error.push(error.statusText);
              this.saved.emit(statusText);
            }
          );
      } else { // ustas - editing an existing calendar
        if (this.keepCalendar['name'] !== this.names[0].name || this.keepCalendar['description'] !== this.names[0].description) {
          const payload = {
            id: this.names[0].id,
            name: this.names[0].name,
            description: this.names[0].description,
          };
          this.request.baseUrl = environment.backEndUrlPrefix;
          this.request.baseUrlAppendByStrParam(('/' + ApiList[ApiList.Db] + '/' + ApiList[ApiList.Calendar]).toLowerCase())
            .updateById(this.names[0].id, payload)
            .subscribe(result => {
                statusText.success.push(this.translate.instant('Item successfully saved'));
                this.saved.emit(statusText);
              }, error => {
                statusText.error.push(error.statusText);
                this.saved.emit(statusText);
              }
            );
        }

        // Удаляем календари, которые больше не нужны
        const idsToDelete = this.keepData
          .filter(_calendarHoliday => !this.calendarHolidays.some(item => item.id === _calendarHoliday.id))
          .map(_calendarHoliday => _calendarHoliday.id);

        let pauseAfterDelete = 0;
        if (idsToDelete.length > 0) {
          pauseAfterDelete = 1000;
          this.request.baseUrl = environment.backEndUrlPrefix;
          this.request.baseUrlAppendByStrParam(('/' + ApiList[ApiList.Db] + '/' + ApiList[ApiList.CalendarHoliday]).toLowerCase())
            .delete({ id: idsToDelete })  // передаем массив id в запросе
            .subscribe(result => {
              statusText.success.push(this.translate.instant('Saved successfully'));
              this.saved.emit(statusText);
            }, error => {
              statusText.error.push(error.statusText);
              this.saved.emit(statusText);
            });
        }

        this.calendarHolidays.forEach(_calendarHoliday => {
          let payload = {};
          if (!_calendarHoliday.id) {
            payload = {
              date: _calendarHoliday.date + this.DAY24,
              weekday: _calendarHoliday.weekday,
              calendar: this.names [0]
            };
            this.request.baseUrl = environment.backEndUrlPrefix;
            this.request.baseUrlAppendByStrParam(('/' + ApiList[ApiList.Db] + '/' + ApiList[ApiList.CalendarHoliday]).toLowerCase())
              .postData(payload)
              .pipe(delay(pauseAfterDelete))
              .subscribe(result => {
                   statusText.success.push(this.translate.instant('Item successfully saved'));
                  this.saved.emit(statusText);
                }, error => {
                  statusText.error.push(error.statusText);
                  this.saved.emit(statusText);
                }
              );
          } else {
            const calendarTmp = this.keepData.filter( item => item.id === _calendarHoliday.id);
            payload = {
              id: _calendarHoliday.id,
              date: _calendarHoliday.date + (calendarTmp[0].date !== _calendarHoliday.date ? this.DAY24 : 0),
              weekday: _calendarHoliday.weekday,
              calendar: this.names [0]
            };
            if (calendarTmp[0].date !== _calendarHoliday.date || calendarTmp[0].weekday !== _calendarHoliday.weekday) {
              this.request.baseUrl = environment.backEndUrlPrefix;
              this.request.baseUrlAppendByStrParam(('/' + ApiList[ApiList.Db] + '/' + ApiList[ApiList.CalendarHoliday]).toLowerCase())
                .postData(payload)
                .pipe(delay(pauseAfterDelete))
                .subscribe(result => {
                    statusText.success.push(this.translate.instant('Item successfully saved'));
                    this.saved.emit(statusText);
                  }, error => {
                    statusText.error.push(error.statusText);
                    this.saved.emit(statusText);
                  }
                );
            }
          }
        });
      }
    } catch (e) {
      this.snackBarService.add(e,
        null,
        {duration: 2000, panelClass: ['c-mat-snack-bar_container__bottom-right', 'c-mat-snack-bar__error']});
    } finally {
      this.saved.emit(statusText);
    }
  }

  /**
   * Добавляет дату переноса выходного дня, дополнительно к производственному календарю
   */
  addCalendarHoliday(): void {
    const now = new Date();
    let tmp = new Date(now.getFullYear(), now.getMonth(), now.getDate() + this.offset).getTime()  - now.getTimezoneOffset() * 60 * 1000;
    let count = 0;
    while (this.map.has(tmp) && count < 365) {
      this.offset += 1;
      count++;
      tmp = new Date(now.getFullYear(), now.getMonth(), now.getDate() + this.offset).getTime()   - now.getTimezoneOffset() * 60 *  1000;
    }
    this.calendarHolidays.push({
      id: 0,  //новый
      date: new Date(now.getFullYear(), now.getMonth(), now.getDate() + this.offset).getTime(),
      weekday: 1
    });
    this.map.set (tmp, 0);

    this.validateEqDate();
  }

  /**
   * Устанавливает шаблон для модального окна и отображает модальное окно
   * @param dialogTemplate - cсылка на шаблон отображения в модальном окне
   */
  confirmSetAction(dialogTemplate) {
    this.modalDialogTemplate = dialogTemplate;
    this.showModalDialog = true;
  }

  changeCalendarHoliday(id): void {
    //Делаем манипуляции с calendarHolidays локально
    let calendarHolidays_= this.calendarHolidays;
    //Создаем новый calendarHolidays
    let calendarHolidays_new = this.calendarHolidays[id];
    calendarHolidays_new.id = 0;  //Обнуляем id.
    //Удаляем calendarHolidays, который хотим изменить
    this.map.delete(this.calendarHolidays[id].date);
    calendarHolidays_= calendarHolidays_.filter((el, idx) => idx !== id);
    //Добавляем новый-замененный
    calendarHolidays_.push(calendarHolidays_new);
    this.map.set(calendarHolidays_new.date, calendarHolidays_new.id);
    //Передаем в this.calendarHolidays изменения + отсортированный по дате
    this.calendarHolidays = calendarHolidays_.sort((a,b) => a.date.toString().localeCompare(b.date.toString()));
    //Валидация на веб-форме
    this.validateEqDate();
  }

  private validateEqDate() {
    this.isDisabled = false;
    this.titleDisabled = '';
    if (this.calendarHolidays && this.calendarHolidays.length > 1) {
      const _clnd = _.cloneDeep(this.calendarHolidays);
      _clnd.forEach(d => {
        (d as any).isWarning = false;
      });
      _clnd.forEach(d => {
        const d0 = new Date(d.date);
        const found = this.calendarHolidays.filter(hd => {
          const d1 = new Date(hd.date);
          return (d1.getMonth() === d0.getMonth() && d1.getDate() === d0.getDate());
        });
        if (found.length > 1) {
          (d as any).isWarning = true;
          this.isDisabled = true;
          this.titleDisabled = 'ERROR_MESSAGES.SAME DATES ARE NOT ALLOWED';
        }
      });
      this.calendarHolidays = _clnd;
    } else if (this.calendarHolidays && this.calendarHolidays.length === 1) {
      (this.calendarHolidays[0] as any).isWarning = false;
    }
  }

  /**
   * Убирает перенос выходного дня
   */
  removeCalendarHoliday(id): void {
    this.map.delete(this.calendarHolidays[id].date);
    this.calendarHolidays = this.calendarHolidays.filter((el, idx) => idx !== id);

    // Проверяем, не стал ли массив пустым перед валидацией
    if (this.calendarHolidays.length === 0) {
      this.isDisabled = false;
      this.titleDisabled = '';
    } else {
      this.validateEqDate();
    }
  }

  /**
   * Скрывает диалог
   */
  hideDialog() {
    this.showModalDialog = false;
  }

  /**
   * Возвращает текущую локаль
   * @returns {string}
   */
  public locale() {
    return this.translate.currentLang;
  }
}
